// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box-shadow[data-v-f60f2948] {\n    border-bottom-color: #e9e9e9;\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n}\n.sticky[data-v-f60f2948] {\n    /* background-color: rgb(48, 65, 86); */\n    background-color: #2d3a4b;\n    background-color: #24262f;\n    background-color: #f8f8f8;\n    text-align: right;\n    line-height: 42px;\n    padding-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
